// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4707":"6e1e908c","6019":"fdc505a8","9420":"b8cce578"}[chunkId] + ".chunk.css";
};